import React from 'react';
import PropTypes from 'prop-types';

import { fromJS } from 'immutable';
import { get } from 'lodash-es';

import { Card, CardText } from 'react-md';

import ItemField from '../../../Components/ItemField/ItemField';
import withToggleView from '../../../Components/ToggleView/ToggleView';
import EditAddresses from './EditAddresses';
import { configAddresses } from '../config';

const style = { maxWidth: 320 };

const BlockAddresses = ({ party, strings, i18n, mode, setViewMode, id, updatePartyAddresses }) => {
  const { fields, initialValues } = configAddresses({ party, strings });

  return mode === 'view' ? (
    <div className="content" key={`addresses-${id}`}>
      {party && Array.isArray(party.addresses)
        ? party.addresses.map(address => (
          <Card style={style} className="cards" key={address.id}>
            <CardText>
              <ItemField
                label={strings['party.edit.block.one_line_street.label'] || 'Voie'}
                value={address.fullAddress}
                name="address.one_line_street"
                optional
              />
              <div className="group">
                <ItemField
                  label={strings['party.edit.block.zip.label'] || 'Code Postal'}
                  value={address.zip}
                  name="address.zip"
                  optional
                />
                <ItemField
                  label={strings['party.edit.block.city.label'] || 'Ville'}
                  value={address.city}
                  name="address.city"
                  optional
                />
                <ItemField
                  label={strings['party.edit.block.country.label'] || 'Pays'}
                  value={address.country.name}
                  name="address.country"
                  optional
                />
              </div>
            </CardText>
          </Card>
            ))
        : undefined}
    </div>
  ) : (
    <div className="content">
      <EditAddresses
        id={party.id}
        setViewMode={setViewMode}
        initialValues={initialValues}
        fields={fields}
        updateAddresses={updatePartyAddresses}
        buttons={{
          submit: strings['party.edit.block.button.submit.label'] || 'Enregistrer les modifications',
          add: strings['party.edit.block.button.add-address.label'] || 'Ajouter une adresse',
        }}
        tooltips={{
          remove: strings['party.edit.block.tooltip.remove-address.label'] || 'Supprimer cette adresse',
          insert: strings['party.edit.block.tooltip.insert-address.label'] || 'Insérer une nouvelle adresse',
        }}
        locale={get(i18n, 'lang', 'fr')}
      />
    </div>
  );
};

BlockAddresses.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  party: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  i18n: PropTypes.object,
  mode: PropTypes.oneOf(['edit', 'view']).isRequired,
  setViewMode: PropTypes.func.isRequired,
  updatePartyAddresses: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

BlockAddresses.defaultProps = {
  party: {},
  strings: {},
  i18n: fromJS({}),
  updatePartyAddresses: params => {
    // eslint-disable-next-line no-console
    console.log('updateAddresses', params);
  },
};

const config = {
  title: 'party.edit.block.addresses.label',
  defaultTitle: 'Adresses',
  name: 'addresses',
  active: true,
};

export default withToggleView(BlockAddresses, config);
